// Shared presentation only: navigation never loads account or order data.
export default function DriverBottomNavigation({activeDriverTab,setActiveDriverTab,text,attendanceEnabled=false,attendanceTitle='',unreadChatCount=0,reportTitle='',visibleTabs=attendanceEnabled?['pool','orders','attendance','conversations','profile']:['pool','orders','conversations','profile']}) {
 return (
      <div className={`driver-bottom-switch ${attendanceEnabled ? 'driver-bottom-switch-with-attendance' : ''}`} role="tablist" aria-label={text.driverSections} style={{gridTemplateColumns:`repeat(${visibleTabs.length},minmax(0,1fr))`}}>
        {visibleTabs.includes('pool') && (<button
          type="button"
          className={activeDriverTab === 'pool' ? 'is-active' : ''}
          onClick={() => setActiveDriverTab('pool')}
          role="tab"
          aria-selected={activeDriverTab === 'pool'}
        >
          <svg className="driver-bottom-switch-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h8M8 12h8M8 17h5M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2z" />
          </svg>
          <span>{text.orderPool}</span>
        </button>)}
        {visibleTabs.includes('orders') && (<button
          type="button"
          className={activeDriverTab === 'orders' ? 'is-active' : ''}
          onClick={() => setActiveDriverTab('orders')}
          role="tab"
          aria-selected={activeDriverTab === 'orders'}
        >
          <svg className="driver-bottom-switch-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5h6M9 3h6a2 2 0 012 2v1h1a2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2h1V5a2 2 0 012-2z" />
          </svg>
          <span>{text.myOrders}</span>
        </button>)}
        {visibleTabs.includes('reports') && <button type="button" role="tab" aria-selected={activeDriverTab==='reports'} className={activeDriverTab==='reports'?'is-active':''} onClick={()=>setActiveDriverTab('reports')}><svg className="driver-bottom-switch-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><path strokeWidth="2" d="M5 3h14v18H5zM8 7h8M8 11h8M8 15h5"/></svg><span>{reportTitle}</span></button>}
        {attendanceEnabled && visibleTabs.includes('attendance') && <button type="button" role="tab" aria-selected={activeDriverTab === 'attendance'} className={activeDriverTab === 'attendance' ? 'is-active' : ''} onClick={() => setActiveDriverTab('attendance')} data-testid="driver-attendance-button">
          <svg className="driver-bottom-switch-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="3" width="16" height="18" rx="2" strokeWidth="2"/><path d="M8 7h8M8 11h3M8 15h3M15 11v6m-2-2h4" strokeWidth="2" strokeLinecap="round"/></svg>
          <span>{attendanceTitle}</span>
        </button>}
        {visibleTabs.includes('conversations') && (<button
          type="button"
          className={activeDriverTab === 'conversations' ? 'is-active' : ''}
          onClick={() => setActiveDriverTab('conversations')}
          role="tab"
          aria-selected={activeDriverTab === 'conversations'}
          data-testid="driver-conversations-tab"
        >
          <span className="driver-bottom-chat-icon-wrap">
            <svg className="driver-bottom-switch-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a8 8 0 01-8 8H6l-3 2 1-4.2A8 8 0 1121 12Z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 10h8M8 14h5" />
            </svg>
            {unreadChatCount > 0 && (
              <span className="driver-chat-unread-badge" aria-label={`${text.unreadMessage} ${unreadChatCount}`} data-testid="driver-chat-unread-badge">
                {unreadChatCount > 99 ? '99+' : unreadChatCount}
              </span>
            )}
          </span>
          <span>{text.conversations}</span>
        </button>)}
        {visibleTabs.includes('profile') && (<button
          type="button"
          className={activeDriverTab === 'profile' ? 'is-active' : ''}
          onClick={() => setActiveDriverTab('profile')}
          role="tab"
          aria-selected={activeDriverTab === 'profile'}
        >
          <svg className="driver-bottom-switch-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM5 21a7 7 0 0114 0" />
          </svg>
          <span>{text.myPageTab || text.myPage}</span>
        </button>)}
      </div>
 );
}
